import React from 'react';
import PropTypes from 'prop-types';
import { IconButton as IconButtonBase, useThemeTokens, getTokensPropType } from '@telus-uds/components-base';
import { jsx as _jsx } from "react/jsx-runtime";
const IconButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    icon = null,
    action,
    tokens = {},
    variant = {},
    ...iconButtonProps
  } = _ref;
  const variantWithAction = action && !variant.action ? {
    ...variant,
    action
  } : variant;
  const {
    icon: themeIcon
  } = useThemeTokens('IconButton', tokens, variantWithAction);
  return (
    /*#__PURE__*/
    // If we want the arrow icons to have directional animation instead of scale, we can pass
    // either appropriate iconTransateX/Y here, or define and pass variants like { direction: 'left' }
    // which have theme rules that set `iconTranslateX` tokens in the theme rules and unset `iconScale`.
    _jsx(IconButtonBase, {
      ref: ref,
      ...iconButtonProps,
      tokens: tokens,
      variant: variant,
      icon: icon ?? themeIcon
    })
  );
});
const multiBrandIconNames = ['add', 'subtract', 'close', 'play', 'moveUp', 'moveDown', 'moveLeft', 'moveRight', 'expand'];
IconButton.displayName = 'IconButton';
const propsWithoutIcon = _ref2 => {
  let {
    icon,
    ...props
  } = _ref2;
  return props;
};
IconButton.propTypes = {
  ...propsWithoutIcon(IconButtonBase.propTypes),
  tokens: getTokensPropType('IconButton'),
  /**
   * To set the icon to a multi-brand compatabile icon
   */
  action: PropTypes.oneOf(multiBrandIconNames),
  /**
   * To set a custom icon
   */
  icon: PropTypes.func
};
export default IconButton;